export default __webpack_public_path__ + "static/media/deck_electron.8231cfaa.webp";